import React from 'react';

export const AboutContentSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Your Go-To Repair Service in Kochi
            </h2>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Device Doctor is your go-to laptop and mobile repair service in Kochi. We specialize in 
              providing high-quality, affordable, and reliable repair solutions for all your electronic 
              devices. Whether it's a smartphone, laptop, or tablet, we ensure top-notch service with every repair.
            </p>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Our team of certified and experienced technicians is equipped to handle all kinds of repairs, 
              from screen replacements, battery fixes, to software troubleshooting. We use only the best 
              spare parts and tools for all repairs to ensure your device runs as good as new.
            </p>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              We also offer on-site repair services and free pick-up to make your experience as convenient 
              as possible. Whether you need repairs for Apple, Samsung, OnePlus, or any other brand, 
              Device Doctor is the trusted repair center in Kochi for all your needs.
            </p>
            
            <div className="bg-red-50 border-l-4 border-red-600 p-6 rounded-r-lg">
              <p className="text-lg text-gray-800 font-medium">
                At Device Doctor, we believe in offering fast, affordable, and efficient repairs with a 
                100% satisfaction guarantee on all our services. You can count on us for reliable mobile 
                and laptop repairs in Kochi.
              </p>
            </div>
          </div>
          
          <div className="relative">
            <img
              src="/assets/about-workshop.jpg"
              alt="Device Doctor repair workshop"
              className="rounded-2xl shadow-xl object-cover w-full h-96"
            />
            
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl p-6 shadow-xl border">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center">
                  <i className="ri-tools-fill text-white text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-lg">Expert Repairs</p>
                  <p className="text-sm text-gray-600">All Device Types</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};